import moment from "moment/moment.js";
import GraphicUtils from "../../../../utils/graphic-utils.js";
import ReportUtils from "../../../../utils/report-utils.js";

export const reportsInfo = {
  status: {reportName: "Status das ocorrências", reportId: "occurrences-status"},
  occurrencesByDay: {reportName: "Ocorrências por dia", reportId: "occurrences-by-day"},
  neighborhoodNature: {reportName: "Ocorrências por bairro e natureza", reportId: "occurrences-neighborhood-reason"},
  natures: {reportName: "Ocorrências por natureza", reportId: "occurrences-reason"},
  naturesWeek: {reportName: "Ocorrências por natureza e por semana", reportId: "occurrences-weekly-reason"},
  individualConditions: {reportName: "Condição dos indivíduos nas ocorrências", reportId: "occurrences-individual-condition"},
  vehicleClassification: {reportName: "Classificação dos veículos nas ocorrências", reportId: "occurrences-vehicles-classification"}
};

const cardLabels = ["Total de ocorrências", "Média diária ocorrências", "Ocorrências concluídas (%)", "Ocorrências com veículos", "Veículos envolvidos", "Indivíduos envolvidos"];

export const translateStatus = (status) => {
  const translations = {AUTOR: "Autor", AVERIGUACAO_CLONE: "Averiguação de clone", CITADO: "Citado", ENVOLVIDO: "Envolvido", FURTADO: "Furtado", NAO_RELACIONADO: "Não relacionado", OUTRO: "Outro", PRODUTO: "Produto", RECUPERADO: "Recuperado", ROUBADO: "Roubado", SUSPEICAO_FRACA: "Suspeição fraca", SUSPEITO: "Suspeito", VITIMA: "Vítima"};
  return translations[status] ?? status;
};

export const exportCards = (data) => ReportUtils.createExportableTable(cardLabels, [data?.total_occ ?? 0, data?.daily_avg ?? 0, data?.percent_concluded ?? 0, data?.vehicles_occ ?? 0, data?.vehicles_qty ?? 0, data?.ind_qty ?? 0], "Cards");

export const createOccurrencesByDayChart = (data, reportInfo) => {
  const dayMap = new Map();
  data.forEach(item => dayMap.set(item.day, (dayMap.get(item.day) || 0) + Number(item.qty)));
  const byWeek = dayMap.size > 31;
  const groupedData = byWeek ? Array.from(dayMap.entries()).reduce((weeks, [day, total]) => {
    const date = moment(day);
    const key = `${date.isoWeekYear()}-${date.isoWeek()}`;
    const week = weeks.get(key) ?? {label: date.startOf("isoWeek").format("DD/MM/YYYY"), total: 0};
    week.total += total;
    weeks.set(key, week);
    return weeks;
  }, new Map()) : new Map(Array.from(dayMap.entries()).map(([day, total]) => [day, {label: moment(day).format("DD/MM/YYYY"), total}]));
  const values = Array.from(groupedData.values()).sort((first, second) => moment(first.label, "DD/MM/YYYY") - moment(second.label, "DD/MM/YYYY"));
  const labels = values.map(item => item.label);
  const quantities = values.map(item => item.total);
  GraphicUtils.lineChart(reportInfo.reportId, [["Ocorrências", ...quantities]], labels);
  if (quantities.some(value => value > 0)) ReportUtils.createExportableTable(labels, quantities, `Ocorrências por ${byWeek ? "semana" : "dia"}`);
};

export const createNeighborhoodNatureChart = (data, reportInfo) => {
  const {labels, values} = ReportUtils.buildStackedData({data, base: "neighborhood", bars: "nature", amountValues: "qty"});
  GraphicUtils.stackedBarChart(reportInfo.reportId, values, labels, "", "", true);
  if (values.length) ReportUtils.createExportableTable(["Natureza", ...labels], values, "Ocorrência bairro natureza");
};

export const createNaturesWeekChart = (data, reportInfo) => {
  const weeks = Array.from(new Set(data.map(item => moment(item.week).startOf("isoWeek").format("DD/MM/YYYY")))).sort((first, second) => moment(first, "DD/MM/YYYY") - moment(second, "DD/MM/YYYY"));
  const natures = Array.from(new Set(data.map(item => item.natures)));
  const natureMap = new Map(natures.map(nature => [nature, {}]));
  data.forEach(item => {
    const week = moment(item.week).startOf("isoWeek").format("DD/MM/YYYY");
    natureMap.get(item.natures)[week] = item.qty;
  });
  const columns = natures.map(nature => [nature, ...weeks.map(week => natureMap.get(nature)[week] || 0)]);
  GraphicUtils.lineChart(reportInfo.reportId, columns, weeks);
  if (columns.length) ReportUtils.createExportableTable(["Natureza", ...weeks], columns, "Ocorrências natureza semana");
};

export const exportIndividualProfile = (data) => {
  const headers = ["Condição", "Quantidade", "Sexo", "Estado civil", "Idade", "Nacionalidade", "Naturalidade"];
  const rows = data.map(item => [ReportUtils.formatText(item.classif), item.qty, ReportUtils.formatText(item.sex), ReportUtils.formatText(item.marital_status), item.age_range, ReportUtils.formatText(item.nationality), item.naturality]);
  if (rows.length) ReportUtils.createExportableTable(headers, rows, "Perfil mais presente por condição");
};

export const exportVehicleProfile = (data) => {
  const headers = ["Classificação", "Quantidade", "Tipo", "Marca/Modelo", "Cor", "Ano de fabricação", "Município da placa"];
  const rows = data.map(item => [translateStatus(item.classif), item.qty, ReportUtils.formatText(item.type), item.brand_model, item.color, item.model_year, item.city_plate]);
  if (rows.length) ReportUtils.createExportableTable(headers, rows, "Perfil presente classificação");
};
